import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var AddVendorVehicleRes;
export const AddVendorVehicleTodo = createAsyncThunk('AddVendorVehicle', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Post",
            url: process.env.REACT_APP_API_URL + 'ven_vehicle_data',
            data: data ,
            headers: { "Content-Type": "multipart/form-data" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return AddVendorVehicleRes = res.data
        
    } catch (error) {
        return AddVendorVehicleRes = error.response.data
    }
})


export var UpdateVendorVehicleRes;
export const UpdateVendorVehicleTodo = createAsyncThunk('UpdateVendorVehicle', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Post",
            url: process.env.REACT_APP_API_URL + 'ven_vehicle_data',
            data: data ,
            headers: { "Content-Type": "multipart/form-data" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return UpdateVendorVehicleRes = res.data
        
    } catch (error) {
        return UpdateVendorVehicleRes = error.response.data
    }
})
